import React, { useEffect, useState } from "react";

export const TxtViewer = ({ url }) => {
  const [textData, setTextData] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchTextData = async (url) => {
      const response = await fetch(url);
      const text = await response.text();
      setTextData(text);
    };
    fetchTextData(url);

    return () => {
      isMounted = false;
    };
  }, [url]);
  return (
    <div className="w-100 h-100">
      <pre>{textData}</pre>
    </div>
  );
};
